import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import reportsAdapter from './generatedReportsEntityAdapter';

import { GENERATED_REPORTS_REDUCER_KEY, type GeneratedReportConfig, type Report } from './generatedReportsTypes';

const slice = createSlice({
  name: GENERATED_REPORTS_REDUCER_KEY,
  initialState: reportsAdapter.getInitialState,
  reducers: {
    generateReport(
      state,
      // FIXME: GeneratedReportConfig has a location field now, and ReportConfiguration also has significant overlap with GeneratedReportConfig. We should probably consolidate those 2 things
      action: PayloadAction<{ location: string; configuration: GeneratedReportConfig }>,
    ) {
      const { payload } = action;
      // We update instead of replace so current report is still available to UI (perhaps UI should become
      // disabled when report is regenerating).
      reportsAdapter.updateOne(state, { id: payload.location, changes: { isGenerating: true } });
    },
    generateReportSuccess(state, action: PayloadAction<{ location: string; report: Report }>) {
      const { payload } = action;
      reportsAdapter.setOne(state, { location: payload.location, report: payload.report, isGenerating: false });
    },
    generateReportFailure(state, action: PayloadAction<{ location: string; error: Error }>) {
      const { payload } = action;
      reportsAdapter.setOne(state, { location: payload.location, error: payload.error, isGenerating: false });
    },
  },
});

export const generatedReportsActions = slice.actions;
export default slice.reducer;
